import { APPS, getMonorepoAppUrl } from '@erinaceus/utils'

export const navItems = [
  {
    label: 'Docs',
    href: `${getMonorepoAppUrl({ app: APPS.WEBSITE })}/docs/price-feed/overview`,
  },
]
